import { genderRenderer } from '../../../helpers/utils/genderRenderer';
import { ProfileTemporary } from '../../../interface/login-modal.interface';
import moment from 'moment';

interface IUserData {
  type: string;
  name: string;
  uid: string;
  activeOfflinePurchaseOrders: number;
  activeOfflineServiceRequests: number;
  activeOnlinePurchaseOrders: number;
  activeOnlineServiceRequests: number;
  activePurchaseOrders: number;
  activeServiceRequestData: any[];
  activeServiceRequests: number;
  astrapaySignature: string;
  address: string;
  buyerList: any[];
  currency: Record<string, any>;
  currentTier: string;
  customerEmail: string;
  customerId: string;
  customerNIK: string;
  customerNo: string;
  customerNoTDMS: string;
  customerQRImage: string;
  dateOfBirth: string;
  defaultAddress: Record<string, any>;
  displayUid: string;
  email: string;
  firstName: string;
  fullName: string;
  gender: string;
  interest1: string;
  interest1List: {
    entry: any[];
  };
  interest2: string;
  interest2List: {
    entry: any[];
  };
  isActive: boolean;
  isEmailVerified: boolean;
  isPhoneVerified: boolean;
  isWAVerified: boolean;
  language: Record<string, any>;
  lastName: string;
  nickName: string;
  occupation: string;
  occupationList: {
    entry: any[];
  };
  otherInterest: string;
  phoneNumber: string;
  referral: string;
  vehicleDetails: any[];
  verifiedDatePhoneNo: string;
  astrapayToken: string | null;
  isProfileCompleteOnline: boolean;
  isUpdatePhone: boolean;
  earnPointNotif: string;
  subInterest1: string;
  subInterest2: string;
  subsFollowerCount: string;
  monthlyIncome: string;
  jobTitle: string;
  jobLevel: string;
  companyName: string;
  industry: string;
  subIndustry: string;
  favoriteFood: string;
  favoriteDrink: string;
  favoriteColor: string;
  occupationOther: string;
  otherIndustry: string;
  otherSubIndustry: string;
  otherJobLevel: string;
  otherSubInterest1: string;
  otherSubInterest2: string;
  otherColor: string;
  city: {
    isocode: string;
    name: string;
  };
  isLoyaltyTierConfig: boolean;
  isQRTierConfig: boolean;
  isQRConfig: boolean;
}

const isO2OProfileHelper = (userData: IUserData, profileTemporary: ProfileTemporary) => {
  const otherHandler = (mainValue = '', otherValue = '') => {
    return mainValue.toLowerCase() === 'lainnya' ? otherValue || '-' : mainValue || '-';
  };
  const currentHobby = userData.interest1 ? userData.interest1 : '-';
  const currentSubHobby = userData.subInterest1
    ? userData.subInterest1.toLowerCase() === 'lainnya'
      ? userData.otherSubInterest1
      : userData.subInterest1
    : '-';

  const occupationWithIncome = ['Petani / Pekebun', 'Peternak', 'Wiraswasta / Pengusaha'];
  const dynamicJobDescription = () => {
    const tempOccupation = (profileTemporary.occupation || userData.occupation || '').toLowerCase();
    if (occupationWithIncome.map((item) => item.toLowerCase()).includes(tempOccupation)) {
      return {
        updatedDataField: 'Pemasukan',
        currentData: userData.monthlyIncome || '-',
        newData: profileTemporary.monthlyIncome || '-',
      };
    } else if (tempOccupation === 'Artis / Influencer'.toLowerCase()) {
      return {
        updatedDataField: 'Jumlah Followers/Subscribers',
        currentData: userData.subsFollowerCount || '-',
        newData: profileTemporary.subscribers || '-',
      };
    } else {
      return {
        updatedDataField: 'Jabatan',
        currentData: otherHandler(userData.jobLevel, userData.otherJobLevel),
        newData: profileTemporary.jobTitle || '-',
      };
    }
  };
  const dynamicJobDesc = dynamicJobDescription();
  const dropdownFields = [
    'Pekerjaan',
    'Pemasukan',
    'Followers',
    'Jabatan',
    'Industri',
    'Sub-Sektor Industri',
    'Hobi',
    'Sub Hobi',
    'Kota',
  ];
  const fields = [
    {
      updatedDataField: 'Nama',
      currentData: userData.name || '-',
      newData: profileTemporary.name || '-',
    },
    {
      updatedDataField: 'Nama Panggilan',
      currentData: userData.nickName || '-',
      newData: profileTemporary.nickName || '-',
    },
    {
      updatedDataField: 'Jenis Kelamin',
      currentData: genderRenderer(userData.gender) || '-',
      newData: genderRenderer(profileTemporary.gender) || '-',
    },
    {
      updatedDataField: 'Tanggal Lahir',
      currentData: userData?.dateOfBirth
        ? moment(userData?.dateOfBirth, 'ddd MMM DD HH:mm:ss [WIB] YYYY', 'en').format('DD/MM/YY')
        : '-',
      newData: profileTemporary?.birthdate
        ? moment(profileTemporary?.birthdate, 'ddd MMM DD HH:mm:ss [WIB] YYYY', 'en').format(
            'DD/MM/YY'
          )
        : '-',
    },
    {
      updatedDataField: 'Kota',
      currentData: userData.city?.isocode || '-',
      newData: profileTemporary.cityAddressCode || '-',
    },
    {
      updatedDataField: 'Alamat',
      currentData: userData.address || '-',
      newData: profileTemporary.address || '-',
    },
    {
      updatedDataField: 'Pekerjaan',
      currentData: otherHandler(userData.occupation, userData.occupationOther),
      newData: profileTemporary?.occupation || '-',
    },

    {
      ...dynamicJobDesc,
    },
    {
      updatedDataField: 'Nama Perusahaan',
      currentData: userData.companyName || '-',
      newData: profileTemporary.companyName || '-',
    },
    {
      updatedDataField: 'Industri',
      currentData: otherHandler(userData.industry, userData.otherIndustry),
      newData: profileTemporary.industry || '-',
    },
    {
      updatedDataField: 'Sub-Sektor Industri',
      currentData: otherHandler(userData.subIndustry, userData.otherSubIndustry),
      newData: profileTemporary.subIndustry || '-',
    },
    {
      updatedDataField: 'Hobi',
      currentData: currentHobby || '-',
      newData: profileTemporary.hobby || '-',
    },
    {
      updatedDataField: 'Sub-Hobi',
      currentData: currentSubHobby || '-',
      newData: profileTemporary.subHobby || '-',
    },
    {
      updatedDataField: 'Makanan Favorit',
      currentData: userData.favoriteFood || '-',
      newData: profileTemporary.favoriteFood || '-',
    },
    {
      updatedDataField: 'Minuman Favorit',
      currentData: userData.favoriteDrink || '-',
      newData: profileTemporary.favoriteDrink || '-',
    },
    {
      updatedDataField: 'Warna Favorit',
      currentData: otherHandler(userData.favoriteColor, userData.otherColor),
      newData: profileTemporary.favoriteColor || '-',
    },
  ];
  const displayedFieldsCaseInsensitive = fields.filter((item) => {
    if (item.newData === '-') return false;
    return item.currentData?.toLowerCase()?.trim() !== item.newData?.toLowerCase()?.trim();
  });
  const displayedFieldsCaseSensitive = fields.filter((item) => {
    if (item.newData === '-') return false;
    return item.currentData?.trim() !== item.newData?.trim();
  });
  return {
    displayedFields: displayedFieldsCaseInsensitive,
    isEligibleO2oProfileSync: displayedFieldsCaseInsensitive?.length > 0,
    caseSensitiveDifference: displayedFieldsCaseSensitive?.length > 0,
  };
};

export default isO2OProfileHelper;
